import styled, { createGlobalStyle } from 'styled-components'
import { defaultTheme } from '~/styles/themes'
import Button from '~/components/Buttons/Button'

export const DisableGlobalScrolling = createGlobalStyle`
  html {
    overflow: hidden; 
  }
`

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${defaultTheme.colors.white};
  z-index: 999;
  overflow: auto;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  gap: 16px;
  padding: 16px;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`

export const ImgError503 = styled.img`
  width: 344px;
  height: 400px;

  @media (max-width: 768px) {
    width: 240px;
    height: 269px;
  }

  @media (orientation: portrait) {
    margin-top: 80px;
  }
`

export const Title = styled.div`
  font-size: 32px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`

export const Description = styled.div`
  > * {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`

export const RetryButton = styled(Button)`
  width: 408px;

  @media (max-width: 768px) {
    width: 100%;
  }
`
